import React from 'react';
import { CheckIcon } from '@fiverr-private/icons';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { List, ListItem, ListItemIcon } from '@fiverr-private/list';
import { PackageDetailsAdvantage } from './types';

interface PackageCardAdvantagesProps {
    advantages: PackageDetailsAdvantage;
}

export const PackageCardAdvantages = ({ advantages }: PackageCardAdvantagesProps) => (
    <Stack rowGap="4" direction="column">
        {advantages.title && (
            <Typography as="h6" size="b_sm">
                {advantages.title}
            </Typography>
        )}

        {advantages && (
            <List padding="0">
                {advantages.list.map((advantage) => (
                    <ListItem key={advantage} direction="row" display="flex" gap="2">
                        <ListItemIcon>
                            <CheckIcon size={16} color="grey_1200" />
                        </ListItemIcon>
                        <Typography size="b_sm" color="grey_1200">
                            {advantage}
                        </Typography>
                    </ListItem>
                ))}
            </List>
        )}
    </Stack>
);
